import PropTypes from 'prop-types';
import { Box, Dialog, DialogTitle } from '@mui/material';

export const ConfigModal = ({ value, open, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth={'md'}>
            <DialogTitle textAlign='center'>Config</DialogTitle>
            <Box display='flex' justifyContent='center'>
                <Box component='pre'>{value}</Box>
            </Box>
        </Dialog>
    );
};

ConfigModal.propTypes = {
    value: PropTypes.string,
    open: PropTypes.bool,
    onClose: PropTypes.func,
};
